import React from 'react';
import { useNavigate } from 'react-router-dom';
import './page_not_found.scss';

const PageNotFound: React.FC = () => {
  const navigate = useNavigate();

  const goToHome = () => {
    navigate('/dashboard');
  };

  return (
    <div className="page-not-found">
      <div className="content">
        <h1>404</h1>
        <h2>Oops! Page Not Found</h2>
        <p>Sorry, the page you're looking for doesn't exist!</p>
        <button onClick={goToHome} className="home-btn">
          Go to Homepage
        </button>
      </div>
    </div>
  );
};

export default PageNotFound;
